import { FormSlot } from '@formily/react-schema-renderer';
export { FormSlot };
export default FormSlot;
